// import config from 'config'
import authHeader from './authHeader'

/** Response Handling Http request
 * @param response
 */
const handleResponse = (response) => {
    return response.text().then(text => {
        // console.log(text);

        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                window.location.reload();
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);

        }

        return data;
    })
}

/** User Login Asnc Function
 * @param credentials username , password
 * @returns Promise
 */
const login = async (username, password) => {
    const requestOptions = {
        method: "POST",
        header: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
    };

    const response = await fetch(`${window.location.origin}/users/authenticate`, requestOptions);
    const user = await handleResponse(response);
    // login successful if there's a user in the response
    if (user) {
        // store user details and basic auth credentials in session storage 
        // to keep user logged in between page refreshes

        user.authdata = window.btoa(username + ':' + password);
        sessionStorage.setItem('user', JSON.stringify(user));
    }

    // console.log(user);

    return user;
}

/** User Register Asnc Function
 * @param object User
 * @returns Promise
 */
const register = async (user) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };

    const response = await fetch(`${window.location.origin}/users/register`, requestOptions);
    return await handleResponse(response);
}

/** Logout Existing User */
const logout = () => {
    // remove user from local storage to log user out
    sessionStorage.removeItem('user');
}


const getAll = async () => {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    // console.log(requestOptions.headers);


    const response = await fetch(`${window.location.origin}/users`, requestOptions);
    //console.log(response);

    return handleResponse(response);
}



/** User Account Functions
 * @method login , logout
 */
export const userService = {
    login,
    logout,
    getAll,
    register,
}

export default userService